export default "__VITE_ASSET__DUtUKxQp__"